import { Provider } from '../../types';
import { GET_SPEED_PASS, GET_SPEED_PASS_CLEAR } from './actions.common';

export const getSpeedpass = (provider: Provider) => ({
  type: GET_SPEED_PASS,
  payload: {
    client: 'amwell',
    request: {
      resourceName: 'getSpeedPass',
      data: { provider }
    }
  }
});

export const dismissSpeedPass = () => ({
  type: GET_SPEED_PASS_CLEAR
});
